/**
 * Return login project id by investor type
 */
export const getLoginProjectID = () => {
  return process.env.REACT_APP_GIP_LOGIN_PROJECT_ID as string;
};
